import { SIDE_NAVIGATION_LINKS } from '@app/constants/sideNavigationLinks';
import SideNavigation from '../SideNavigation';

const TherapistProfileSideNavigation = () => {
  return <SideNavigation data={SIDE_NAVIGATION_LINKS.therapistProfile} />;
};

export default TherapistProfileSideNavigation;
